import { ref } from "vue";

export default ref({
	companies: [],
	industries: [],
	countries: [],
	sizes: [],
	country_name: "",
	industry_name: "",
	search: "",
	page: 1,
	total: 0,
	per_page: 10,
	column: "name",
	sort: "asc",
	loading: false,
	selectedCountries: [],
	selectedIndustries: [],
	selectedSectors: [],
	selectedSizes: [],
	reload: 1,
});
